import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LabelAndValue } from '../../../global/components/data-display/label-value';
import { GuidedProcessSupportBlock } from '../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { SideBarContent } from '../../../global/components/layout/sidebar-content';
import { TcsmModal } from '../../../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getPodsContent } from '../../../global/ducks/epi-api';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DcData, MyCpgPodsSettings, PodContent } from '../mycpg-pod-models';


interface Props {
	settings: MyCpgPodsSettings;
}
export function DcPlanDetail(props: Props) {

	const { settings } = props;
	const dcPlan = useSelector<TcsmStates, DcData>(state => state?.mycpgPodsState?.pods?.dc_data);
	const [planDetail, setPlanDetail] = useState<any>('');
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();
	const notEnrolled = dcPlan?.content === PodContent.NOT_ENROLLED;
	useEffect(() => {
		if (dcPlan?.data?.content_path) {
			dispatch(getPodsContent(dcPlan?.data?.content_path, (data) => setPlanDetail(data?.contentHtml)));
		}
	}, []);


	const handleClose = () => {
		setOpen(false);
	};


	const onPlanDetailClick = () => {
		setOpen(true);
	};

	const renderDcPlan = () => {
		if (!dcPlan?.data || Object.keys(dcPlan?.data)?.length === 0) return null;

		return (
			<DividerSection sectionText={settings?.dcPlanTitle}>
				<ContentSpacer>
					<p className='h3-styled'>{getCurrencyFormat(dcPlan?.data?.total_balance)}</p>
					{dcPlan?.as_of_date === YesNoIndicators.Yes && <p className='grey-caption'>{settings?.balanceDateLabel?.replace('{date}', dcPlan?.data?.as_of_date)}</p>}
				</ContentSpacer>
				{dcPlan?.data?.status && <LabelAndValue label={settings?.statusLabel} value={<p className={dcPlan?.data?.status === 'Active' ? 'green-text' : 'red-text'}><strong>{dcPlan?.data?.status}</strong></p>} />}
				{dcPlan?.employer_base === YesNoIndicators.Yes && <LabelAndValue label={settings?.employerBaseLabel} tooltipMessage={settings?.employerBaseHelper} value={dcPlan?.data?.employer_base === 'N/A' ? dcPlan?.data?.employer_base : `${dcPlan?.data?.employer_base}%`} />}
				{dcPlan?.employer_match === YesNoIndicators.Yes && <LabelAndValue label={settings?.employerMatchLabel} tooltipMessage={settings?.employerMatchHelper} value={dcPlan?.data?.employer_match === 'N/A' ? dcPlan?.data?.employer_match : `${dcPlan?.data?.employer_match}%`} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.deferralAmountLabel} tooltipMessage={settings?.deferralAmountHelper} value={getCurrencyFormat(dcPlan?.data?.benefit_pretax_amount)} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.deferralPercentLabel} tooltipMessage={settings?.deferralPercentHelper} value={`${dcPlan?.data?.benefit_pretax_percent}%`} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.rothDeferralAmountLabel} tooltipMessage={settings?.rothDeferralAmountTooltip} value={getCurrencyFormat(dcPlan?.data?.benefit_roth_amount)} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.rothDeferralPercentLabel} tooltipMessage={settings?.rothDeferralPercentTooltip} value={`${dcPlan?.data?.benefit_roth_percent}%`} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.afterTaxDeferralAmountLabel} tooltipMessage={settings?.afterTaxDeferralAmountTooltip} value={getCurrencyFormat(dcPlan?.data?.benefit_aftertax_amount)} />}
				{dcPlan?.data?.deferral_flag && <LabelAndValue label={settings?.afterTaxDeferralPercentLabel} tooltipMessage={settings?.afterTaxDeferralPercentTooltip} value={`${dcPlan?.data?.benefit_aftertax_percent}%`} />}
				{dcPlan?.loans === YesNoIndicators.Yes && <LabelAndValue label={settings?.numberOfLoansLabel} value={dcPlan?.data?.loan_count} tooltipMessage={settings?.numberOfLoansHelper} />}
				{dcPlan?.data?.total_loan_amount > 0 && <LabelAndValue label={settings?.totalLoanAmountLabel} value={getCurrencyFormat(dcPlan?.data?.total_loan_amount)} />}
				{dcPlan?.withdrawal === YesNoIndicators.Yes && <LabelAndValue label={settings?.withdrawalLabel} value={getCurrencyFormat(dcPlan?.data?.total_withdrawal)} />}
				{dcPlan?.withdrawal_date === YesNoIndicators.Yes && <LabelAndValue label={settings?.withdrawalDateLabel} value={dcPlan?.data?.withdrawal_date} />}
				{
					dcPlan?.data?.content_path &&
					<ContentSpacer>
						<button className='link-button' type='button' onClick={onPlanDetailClick}>{settings?.planDetailButtonLabel}</button>
					</ContentSpacer>
				}
				<ContentSpacer>
					<WysiwygWithReactLink content={settings?.dcPlanDetailMessage} />
				</ContentSpacer>
			</DividerSection>
		);

	};

	const renderDetailSection = () => {

		return (
			<>
				{
					renderDcPlan()
				}
			</>);

	};

	return (
		<>
			<PageHeader headerText={settings?.pensionPlanDcDetailTitle} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={settings?.dcGpsTitle} contents={settings?.dcGps} />
				</SideBarContent>
			</Hidden>
			{
				notEnrolled ?
					<DividerSection removeDivider>
						<WysiwygWithReactLink content={settings?.dcPlanNotEnrolledMessage} />
					</DividerSection>
					:
					<>
						<TcsmModal
							open={open}
							handleClose={handleClose}
						>
							<WysiwygWithReactLink content={planDetail} />
						</TcsmModal>
						{

							renderDetailSection()
						}
					</>
			}
		</>
	);

}

